import { Container, Typography } from '@mui/material';
import React from 'react';

export default function Footer() {
  return (
    <Container
      sx={{
        padding: '80px 0px 0px 0px',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}>
        <Typography variant="body1">
          تمامی حقوق مادی و معنوی این سرویس برای ماهرها محفوظ است.
        </Typography>
        <Typography variant="body1">
          طراحی و توسعه با ❤️ توسط{' '}
          <a
            href="https://svasighi.ir"
            style={{
              fontWeight: 900,
              textDecoration: 'none',
              color: 'inherit',
            }}>
            شادمهر وثیقی
          </a>
        </Typography>
      </div>
    </Container>
  );
}
